// extracted by mini-css-extract-plugin
module.exports = {"modal":"_3qp0Qe","buttons":"_2dJYJR","button":"ag9TzF","unsubscribeProductsModal":"_2yBHUj","productContainer":"_3Vn-bS","products":"_2Qv6O3"};